import BaseComponent from "../../../baseComponent.js";
import DatasetService from "../../../../core/services/datasetService.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import CreateDataProfileFields from "./createDataProfileFields.jsx";
import UniqueIdGenerator from "../../../../core/utils/uniqueIdGenerator.js";
import styles from "../../../common/modal.scss";

export default class CreateDataProfile extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = this.getDefaultState();
  }

  componentDidMount() {
    this.$modal = $("#create-data-profile-modal");
    this.$modal.modal({
      dismissible: false
    });
  }

  show() {
    this.$modal.modal("open");
  }

  getDefaultState() {
    return {
      page: 1,
      dataProfile: {
        name: "",
        description: "",
        fields: [this.getEmptyField()]
      },
      validity: {
        name: "",
        fields: []
      }
    }
  }

  handleInputChange(event, fieldName) {
    let dataProfile = this.state.dataProfile;
    let validity = this.state.validity;
    dataProfile[fieldName] = event.target.value;
    validity[fieldName] = "";
    this.setState({
      dataProfile: dataProfile,
      validity: validity
    });
  }

  next() {
    this.refs.tab1.setAttribute("class", "slide-out-reverse");
    this.setState({
      page: 2
    });
  }

  previous() {
    this.refs.tab1.setAttribute("class", "slide-in-reverse");
    this.setState({
      page: 1
    });
  }

  close() {
    let state = this.getDefaultState();
    this.setState(state);
    this.$modal.modal("close");
    this.refs.tab1.setAttribute("class", "");
  }

  create() {
    let _this = this;

    if (this.validate()) {

      this.publish(InternalEvent.App.SHOW_PRELOADER, "");
      let dataProfile = this.state.dataProfile;

      for (let i = 0; i < dataProfile.fields.length; i++) {
        delete dataProfile.fields[i].error;
      }

      DatasetService.createDataProfile(dataProfile).then(() => {
        _this.close();
        _this.publish(InternalEvent.App.HIDE_PRELOADER, "");
        setTimeout(() => {
          this.$modal.modal("close");
        }, 200);
      });
    }
  }

  onFieldAdded(field) {
    let profile = this.state.dataProfile;
    profile.fields.push(field);
    this.setState({
      profile: profile
    });
  }

  getEmptyField() {
    return {
      name: "",
      fieldId: "",
      valueType: "",
      maxLength: null,
      persistenceId: UniqueIdGenerator.uuid(),
      error: [this.getEmptyErrorMap()]
    }
  }

  getEmptyErrorMap() {
    return {
      name: "",
      id: "",
      valueType: "",
      maxLength: ""
    }
  }

  checkFields(profile) {
    let valid = 1;
    for (let i = 0; i < profile.fields.length; i++) {
      if (i < profile.fields.length - 1 || i == 0) {
        if (profile.fields[i].name == "") {
          valid = 0;
          profile.fields[i].error[0].name = "input-error-border";
        }
        if (profile.fields[i].fieldId == "") {
          valid = 0;
          profile.fields[i].error[0].id = "input-error-border";
        }

        if (profile.fields[i].valueType == "") {
          valid = 0;
          profile.fields[i].error[0].valueType = "input-error-border";
        }
        else if (profile.fields[i].valueType != "") {
          if (profile.fields[i].maxLength == null && profile.fields[i].valueType == "8" || isNaN(profile.fields[i].maxLength) && profile.fields[i].valueType == "8") {
            valid = 0;
            profile.fields[i].error[0].maxLength = "input-error-border";
          }
          else if (profile.fields[i].maxLength == "" && profile.fields[i].valueType == "8" || profile.fields[i].maxLength == "NaN" && profile.fields[i].valueType == "8") {
            valid = 0;
            profile.fields[i].error[0].maxLength = "input-error-border";
          }
        }
      }

      if (profile.fields[i].name == "" && profile.fields[i].fieldId == "" && i == (profile.fields.length - 1) && i > 0) {
        this.onFieldRemoved(profile.fields[i]);
      }
      else if (profile.fields[i].name != "" && i == (profile.fields.length - 1) && i > 0 || isNaN(profile.fields[i].fieldId) && i == (profile.fields.length - 1) && i > 0) {

        if (profile.fields[i].name == "") {
          valid = 0;
          profile.fields[i].error[0].name = "input-error-border";
        }
        if (profile.fields[i].fieldId == "") {
          valid = 0;
          profile.fields[i].error[0].id = "input-error-border";
        }

        if (profile.fields[i].valueType == "") {
          valid = 0;
          profile.fields[i].error[0].valueType = "input-error-border";
        }
        else if (profile.fields[i].valueType != "") {
          if (profile.fields[i].maxLength == null && profile.fields[i].valueType == "8" || isNaN(profile.fields[i].maxLength) && profile.fields[i].valueType == "8") {
            valid = 0;
            profile.fields[i].error[0].maxLength = "input-error-border";
          }
          else if (profile.fields[i].maxLength == "" && profile.fields[i].valueType == "8" || isNaN(profile.fields[i].maxLength) && profile.fields[i].valueType == "8") {
            valid = 0;
            profile.fields[i].error[0].maxLength = "input-error-border";
          }
        }
      }
    }


    return !valid;
  }

  validate() {
    let valid = true;
    let profile = this.state.dataProfile;
    let validity = this.state.validity;

    if (profile.name.trim().length === 0) {
      valid = false;
      validity.name = "invalid";
      this.previous();
    }

    if (this.checkFields(profile)) {
      valid = false;
      validity.name = "invalid";
    }

    this.setState({
      validity: validity
    });

    return valid;
  }

  onFieldRemoved(field) {
    let profile = this.state.dataProfile;
    for (let i = 0; i < profile.fields.length; i++) {
      if (profile.fields[i].persistenceId === field.id) {
        profile.fields.splice(i, 1);
        break;
      }
      if (profile.fields[i].persistenceId === field.persistenceId) {
        profile.fields.splice(i, 1);
        break;
      }
    }
    this.setState({
      profile: profile
    });
  }

  handleAddBtnClicked() {
    this.state.dataProfile.fields.push(this.getEmptyField());
    this.setState({
      dataProfile: this.state.dataProfile
    });
  }

  handleChanges(state) {
    let dataProfile = this.state.dataProfile;
    let validity = this.state.validity;
    let fields = state;


    for (let i = 0; i < dataProfile.fields.length; i++) {
      if (dataProfile.fields[i].persistenceId == state.id) {
        dataProfile.fields[i].name = state.name;
        if (dataProfile.fields[i].name != "") {
          dataProfile.fields[i].error[0].name = "";
        }
        dataProfile.fields[i].fieldId = state.fieldId;
        if (dataProfile.fields[i].fieldId != "") {
          dataProfile.fields[i].error[0].id = "";
        }
        dataProfile.fields[i].valueType = state.valueType;
        if (dataProfile.fields[i].valueType != "") {
          dataProfile.fields[i].error[0].valueType = "";
        }
        dataProfile.fields[i].maxLength = state.maxLength;
        if (dataProfile.fields[i].maxLength != "") {
          dataProfile.fields[i].error[0].maxLength = "";
        }
        dataProfile.fields[i].persistenceId = state.id;
        if ((i == dataProfile.fields.length - 1) && (i > 0)) {
          dataProfile.fields[i].error[0].name = "";
          dataProfile.fields[i].error[0].id = "";
          dataProfile.fields[i].error[0].valueType = "";
          dataProfile.fields[i].error[0].maxLength = "";
        }
      }
    }

    this.setState({
      dataProfile: dataProfile,
      validity: validity
    });

  }

  handleFieldChanged(field) {
    let isNew = true;
    let fields = this.state.dataProfile.fields.slice();
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].persistenceId === field.persistenceId) {
        fields[i] = field;
        isNew = false;
        break;
      }
    }

    if (isNew) {
      fields.push(field);
    }

    this.state.dataProfile.fields = fields;
    this.setState({
      dataProfile: this.state.dataProfile
    });
  }

  render() {
    let btns = [];

    if (this.state.page === 1) {
      btns.push(<button
        className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')} key="0"
        onClick={e => this.close(e)}>Cancel</button>);
      btns.push(<button className={[styles.actionButton, "btn waves-effect"].join(' ')}
                        key="1" onClick={e => this.next(e)}>Next</button>);
    } else {
      btns.push(<button
        className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')} key="2"
        onClick={e => this.previous(e)}>Previous</button>);
      btns.push(<span style={{flex: 1}} key="3"/>);
      btns.push(<button
        className={[styles.actionButton, styles.cancelButton, "btn-flat modal-close waves-effect"].join(' ')} key="4"
        onClick={e => this.close(e)}>Cancel</button>);
      btns.push(<button className={[styles.actionButton, "btn waves-effect"].join(' ')} key="5"
                        onClick={e => this.create(e)}>Create</button>);
    }

    return (
      <div id="create-data-profile-modal" className={[styles.modal, "modal"].join(' ')} style={{width: 550}}>
        <div className="modal-wrapper">
          <div className="modal-content">
            <div ref="tab1" style={{zIndex: 1}}>
              <h5>Create DataProfile</h5>
              <div className="row" style={{margin: '0 -1.4rem'}}>
                <form className="col s12">
                  <div className="row">
                    <div className="input-field col s12">
                      <input id="profile_name" type="text" className={this.state.validity.name}
                             value={this.state.dataProfile.name}
                             onChange={e => this.handleInputChange(e, "name")}/>
                      <label htmlFor="profile_name">DataProfile Name</label>
                    </div>
                  </div>
                  <div className="row">
                    <div className="input-field col s12">
                      <textarea id="profile_desc" className="materialize-textarea"
                                value={this.state.dataProfile.description}
                                onChange={e => this.handleInputChange(e, "description")}/>
                      <label htmlFor="profile_desc">Description</label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div ref="tab2">
              <h5>Add Fields</h5>
              <div className="row" style={{margin: '0 -0.7rem'}}>
                <form className="col s12">
                  <div className="row">
                    <CreateDataProfileFields fields={this.state.dataProfile.fields}
                                             removeField={this.onFieldRemoved}
                                             onFieldChanged={this.handleFieldChanged}
                                             onAddBtnClicked={this.handleAddBtnClicked}
                                             addField={field => this.onFieldAdded(field)}
                                             onChanges={this.handleChanges}/>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className={styles.footer}>
            {btns}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/create/dataprofile/createDataProfile.jsx